module.exports = __webpack_public_path__ + "static/media/Screen Shot 2021-07-20 at 2.45.38 PM.69a1e964.png";